import type { RouteErrorComponents } from "@shuttlerock/error-handling";
import { Loading } from "../Loading/Loading";
import { TopLevelErrorBoundary } from "./TopLevelErrorBoundary";

/**
 * The app's overrides for `RouteErrorBoundary`, shared by the root and any
 * route with its own boundary, so a crash below the root still gets the root's
 * recovery: the env-config refresh and the one-time reload on a ChunkLoadError.
 */
export const routeErrorComponents: Partial<RouteErrorComponents> = {
  Crash: TopLevelErrorBoundary,
  LoginRequired: Loading,
};
